import SearchPredictableRisks from './Constructor'

export default SearchPredictableRisks
export { SearchPredictableRisks }
